import React from "react";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";

export const MainMenuFavoritesItem = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function MainMenuFavoritesItem(props: {
			store: PrematchOfferMenuStore;
		}) {
			const { t } = useTranslation();
			const location = useLocation();
			const rootStore = useRootAppStore();

			if (!rootStore.userAuthStore.isLoggedIn) {
				return null;
			}

			return (
				<li className="nav--secondary__item nav--sports__item">
					<button
						className={classnames(`nav--secondary__link`, {
							"is-expanded": props.store.isFavoritesSubMenuOpen,
							"is-selected":
								location.pathname.includes("my-favorites"),
						})}
						onClick={() => {
							props.store.toggleFavoritesMenu();
						}}
					>
						<i
							className={`nav--secondary__icon u-icon u-icon--lrg u-icon--favorites`}
						/>

						<div className="nav--secondary__title">
							{t("SPORTS_MENU.MY_FAVORITES.TITLE")}
						</div>
						{/* <span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
					{favoritesStore.prematchFavoritesCount}
				</span> */}
					</button>
				</li>
			);
		});
